









import Vue from "vue";
import { mapGetters } from "vuex";
import * as types from "../store/types";

export default Vue.extend({
  computed: {
    ...mapGetters({
      closed: types.APP_CLOSED,
    }),
  },
});
